import PrefixEnum from '../prefixes'

export default Object.freeze({
    'get-strong.gymondo.fitness': PrefixEnum.GET_STRONG,
})
